import EffectsView from 'components/effects/EffectsView.js';
import React from 'react';

export function getEffectsComponent(track, scrollContainer, isRack=false) {
    let {sequencerEngine} = track;
    return (
        <EffectsView
          scrollContainer={scrollContainer}
          hideLock={true}
          isRack={isRack}
          store={sequencerEngine.store}
          sequencerEngine={sequencerEngine}
          onParameterChanged={(parameter) => []}
          onEffectsChange={() => track.updateEffects()}
          panning={0}
          onChangePanning={(i) => console.log('panning changed = ' + i)}
          sends={sequencerEngine.sends}
          tracks={[]}
          track={track}
          send={undefined}
          group={undefined}/>);
}

